import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-texto-principal-planes',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './texto-principal-planes.component.html',
  styleUrl: './texto-principal-planes.component.scss'
})
export class TextoPrincipalPlanesComponent implements OnInit {
  @Input() nombreTextoPrincipal!: string;
  @Input() textoInferior!: string;

  constructor() { }

  ngOnInit(): void {
  }

}
